// src/components/UI/TourAndTourism/destinations.js
import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = 'https://eventscons.com/eventbackendnew/api/all-trip?trip_type=general';

export const useDestinations = () => {
  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(API_URL, {
          headers: {
            'Authorization': 'Bearer YOUR_TOKEN_HERE', // Apna token yahan daalo
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        });
        
        const apiTrips = response.data.trips || [];
        console.log('API Response:', apiTrips[0]); // Debug check
        
        const dynamicData = apiTrips.map((trip, index) => ({
          id: trip.id || index,
          title: trip.name || 'Trip',
          description: trip.description || trip.additional_info || 'No description available',
          images: [
            trip.image_1 ? `https://eventscons.com/eventbackendnew/storage/app/public/${trip.image_1}` : '',
            trip.image_2 ? `https://eventscons.com/eventbackendnew/storage/app/public/${trip.image_2}` : '',
            trip.image_3 ? `https://eventscons.com/eventbackendnew/storage/app/public/${trip.image_3}` : '',
            trip.image_4 ? `https://eventscons.com/eventbackendnew/storage/app/public/${trip.image_4}` : '',
            trip.image_5 ? `https://eventscons.com/eventbackendnew/storage/app/public/${trip.image_5}` : ''
          ].filter(Boolean),
          // 🔥 TEENO PRICE FIELDS - YE MAIN FIX HAI:
          price_per_person: trip.price_per_person || "0.00",
          price_for_two: trip.price_for_two || "0.00",
          price_for_three_or_more: trip.price_for_three_or_more || "0.00"
        }));
        
        console.log('Final Data with Prices:', dynamicData[0]); // Price verify karo
        setDestinations(dynamicData);
      } catch (error) {
        console.error('API Error:', error.response?.status, error.response?.data);
        
        if (error.response?.status === 401) {
          setDestinations([{
            id: 1,
            title: "API Access Required",
            description: "Contact admin for API access",
            images: ['https://via.placeholder.com/400x300/9B1321/FFFFFF?text=No+Data'],
            price_per_person: "0.00",
            price_for_two: "0.00", 
            price_for_three_or_more: "0.00"
          }]);
        } else {
          setDestinations([]);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { destinations, loading };
};

export default [];